<template>
  <van-row >
     <!-- el-image在IE下会自动加上用于兼容object-fit的类，该类的样式在没设置图片宽高是会 GG -->
    <van-image
        width="250"
        height="250"
        :src="imageUrl"
        @load="onImageLoaded"
        @click="handlePreview"
    >
      <template v-slot:loading>
        <van-loading type="spinner" v-if="showProgressBar" size="20" />
      </template>
    </van-image>

<!--    环形进度条<img class="image-element" :src="imageUrl" @load="onImageLoaded" @click="handlePreview" />
<el-progress
      v-if="showProgressBar"
      :percentage="percentage"
      :color="percentage => (percentage === 100 ? '#67c23a' : '#409eff')"
    />-->
<!--    <van-progress

        :percentage="percentage"
    />-->
  </van-row>
</template>

<script>
import { mapGetters } from 'vuex'
import {ImagePreview} from 'vant'
export default {
  name: 'ImageElemnt',
  props: {
    payload: {
      type: Object,
      required: true
    },
    message: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean
    }
  },
  components: {
  },
  computed: {
    ...mapGetters('conversation',['imgUrlList']),
    imageUrl() {
      const url = this.payload.imageInfoArray[0].url
      if (typeof url !== 'string') {
        return ''
      }
      return url.slice(0, 2) === '//' ? `https:${url}` : url
    },
    showProgressBar() {
      return this.message.status === 'unSend'
    },
    percentage() {
      return Math.floor((this.message.progress || 0) * 100)
    }
  },
  methods: {
    onImageLoaded(event) {
      this.$bus.$emit('image-loaded', event)
    },
    handlePreview() {
      /*this.$bus.$emit('image-preview', {
        url: this.payload.imageInfoArray[0].url
      })*/
      ImagePreview({
        images:[this.imageUrl],
        closeable: true,
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.image-element
  max-width 250px
  cursor zoom-in

</style>
